import React from "react";
import PropTypes from "prop-types";
import { Button } from "elements/Button/Button";
import { Price } from "../../Price/Price";
import { FeatureTags } from "../../FeatureTags/FeatureTags";
import { Specifications } from "./Specifications/Specifications";
import { CircleButton } from "elements/Button/CircleButton";
import { ReactComponent as Heart } from "assets/icons/heart.svg";
import VisibleLeadTime from "../../VisibleLeadTime/VisibleLeadTime";

import "./SmallDerivativeCard.scss";

export const SmallDerivativeCard = props => {
  const { shortlistData, vehicleId, calculationParameters } = props;
  const { isLoading, shortlist, vehicleId: savingVehicleId } = shortlistData;
  const { annualMileage, duration } = calculationParameters;
  const shortlistItem = shortlist.find(
    vehicle =>
      vehicle.vehicleId === vehicleId &&
      vehicle.calculationParameters.annualMileage === annualMileage &&
      vehicle.calculationParameters.duration === duration,
  );
  const isSelected = shortlistItem ? true : false;

  return (
  <div className="small-derivative-card">
    <header className="small-derivative-card__heading">
        <div className="small-derivative-card__titles">
          <h2 className="small-derivative-card__title">{props.heading}</h2>
          <h3 className="small-derivative-card__title small-derivative-card__title--model">
            {props.subHeading}
          </h3>
        </div>
        <CircleButton
          clickHandler={() => props.handleSaveToShortlist(props.vehicleId)}
          title={"Save Vehicle"}
          render={() => <Heart />}
          isLoading={isLoading && vehicleId === savingVehicleId}
          isSelected={isSelected}
          isDisabled={isSelected}
        />
    </header>
    <section className="small-derivative-card__body">
      <div className="small-derivative-card__row small-derivative-card__row--tags">
        <FeatureTags tags={props.features} />
      </div>
      <div className="small-derivative-card__row ">
        <Price className="small-derivative-card__price" {...props.price} />   
        {props.vehicleLeadTimes && (
            <div className="visible-lead-time"> 
                <VisibleLeadTime {...props.vehicleLeadTimes} />
            </div>
        )}  
      </div>
      <div className="small-derivative-card__spec">
        <Specifications specifications={props.specifications} />
      </div>      
      <div className="small-derivative-card__cta">
        <Button {...props.primaryButton} onClick={props.onPrimaryButtonClick} />
      </div>
    </section>
  </div>
);
};

SmallDerivativeCard.propTypes = {
  subHeading: PropTypes.string.isRequired,
  heading: PropTypes.string.isRequired, 
  price: PropTypes.object.isRequired,
  specifications: PropTypes.array.isRequired,
  handleSaveToShortlist: PropTypes.func.isRequired,
  onPrimaryButtonClick: PropTypes.func.isRequired,
  shortlistData: PropTypes.object.isRequired,
};

SmallDerivativeCard.defaultProps = {
  specifications: [],
};
